export const CLIENT_BASE_KEY = 'clients';

export const clientsApiQueryKeys = {
  all: () => [CLIENT_BASE_KEY] as const,
  byId: (clientId: string) => [CLIENT_BASE_KEY, clientId] as const,
  details: (clientId: string) =>
    [CLIENT_BASE_KEY, clientId, 'details'] as const,
  bookingDetailsByTour: (clientId: string, tourId: string) =>
    [CLIENT_BASE_KEY, clientId, 'tours', tourId, 'booking-details'] as const,
};
